import React from 'react'

type Props = {}

export default function MferHeads({}: Props) {
  return (
    <div><br></br><br></br><br></br><br></br><br></br><br></br>MferHeads</div>
  )
}